import React, { Suspense } from "react";
import ColorFilter from "@/components/Filters/ColorFilter";
import CostFilter from "@/components/Filters/CostFilter";
import PowerFilter from "@/components/Filters/PowerFilter";
import NameFilter from "@/components/Filters/NameFilter";
import TypeFilter from "@/components/Filters/TypeFilter";
import CounterFilter from "@/components/Filters/CounterFilter";
import AttributeFilter from "@/components/Filters/AttributeFilter";
import DeckCommonCardsFilter from "@/lib/games/onePiece/DeckCommonCardsFilter";
import FormatFilter, { formats } from "@/components/Filters/FormatFilter";
import ShowAAsFilter from "@/components/Filters/ShowAAsFilter";
import {
  Image,
  Button,
  Tooltip,
  Card,
  Pagination,
  Spinner,
  useDisclosure,
} from "@heroui/react";
import {
  IconLayoutBottombar,
  IconLayoutSidebar,
  IconMaximize,
  IconX,
} from "@tabler/icons-react";
import { useCardDBInfiniteScroll } from "@/components/DeckBuilder/hooks/useCardDBInfiniteScroll";
import { Droppable } from "@/components/dnd/Droppable";
// import { DndContext } from "@dnd-kit/core";
import DeckCardLeftSide from "@/components/DeckBuilder/DeckCardLeftSide";
import { SortableItem } from "@/components/dnd/SortableItem";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { DeckItem } from "@/types/deck";
import {
  useCardOrderIds,
  useSetCardOrderIds,
  useAddCard,
} from "@/stores/deckStore";

export default function DeckLayoutLeftSide({
  getCount,
  copyDeck,
  deck,
  filters,
  setFilter,
  deckCardsMap,
  clearAllFilters,
  displayCards,
  handleOpen,
  setLayout,
  hasNextPage,
  fetchNextPage,
  page,
  clearNewDeck,
}: {
  getCount: any;
  copyDeck: any;
  deck: any;
  filters: any;
  setFilter: any;
  clearAllFilters: any;
  deckCardsMap: any;
  displayCards: any;
  handleOpen: any;
  setLayout: any;
  hasNextPage: any;
  fetchNextPage: any;
  page: number;
  clearNewDeck: any;
}) {
  const cardOrderIds = useCardOrderIds();
  const setCardOrderIds = useSetCardOrderIds();
  const addCard = useAddCard();
  const { scrollRef, sentinelRef } = useCardDBInfiniteScroll({
    hasNextPage,
    fetchNextPage,
    resetOnChange: filters,
    page,
  });
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  function handleDragEnd(event: any) {
    console.log("handleDragEnd");
    const { active, over } = event;

    if (active.id !== over.id) {
      console.log("activeid", active.id, "overid", over.id);
      setCardOrderIds((prevCardOrderIds: any) => {
        // const oldIndex = items.findIndex((x) => {
        //   return x.order;
        // });
        const oldIndex = prevCardOrderIds.indexOf(active.id);
        const newIndex = prevCardOrderIds.indexOf(over.id);

        return arrayMove(prevCardOrderIds, oldIndex, newIndex);
      });
    }
  }

  // useEffect(() => {
  //   const deckItems = deck.get();
  //   const deckIdsSet = new Set(deckItems.map((item: DeckItem) => item.id));

  //   setCardOrderIds((prevCardOrderIds: any) => {
  //     // Filter out ids that no longer exist in the deck
  //     const filteredItems = prevCardOrderIds.filter((id: string) =>
  //       deckIdsSet.has(id),
  //     );

  //     // Add new ids from the deck that are not already in items
  //     const newIds = deckItems
  //       .map((item: DeckItem) => item.id)
  //       .filter((id: string) => !filteredItems.includes(id));

  //     // Preserve the order by concatenating new IDs at the end
  //     return [...filteredItems, ...newIds];
  //   });
  // }, [deck.get().length]);

  // let displayDeck = React.useMemo(() => {
  //   let displayDeck = [];
  //   for (const deckCard of deck.get()) {
  //     displayDeck.push(
  //       <SortableItem key={deckCard.id}>
  //         <DeckCardLeftSide
  //           key={deckCard.id}
  //           id={deckCard.id}
  //           count={deckCard.count}
  //           addCard={addCard}
  //         />
  //       </SortableItem>,
  //     );
  //   }
  //   return displayDeck;
  // }, [deck]);

  return (
    // </DndContext>
    <div>
      <div className="grid-cols-4 grid gap-4">
        <div className="col-span-1 relative">
          <div className="">
            <div className="h-[72px] mt-4 mb-4">
              <div>{getCount()} cards</div>
              <div className="grid grid-cols-3 gap-2">
                <Button
                  size="sm"
                  variant="ghost"
                  color="primary"
                  onPress={() => copyDeck()}
                >
                  Copy
                </Button>
                {/* <Button size="sm" onPress={() => validateDeck()}>
              Validate
            </Button> */}
                <Button
                  size="sm"
                  variant="ghost"
                  color="danger"
                  onPress={() => {
                    clearNewDeck();
                  }}
                >
                  Clear
                </Button>
                <Button
                  size="sm"
                  isIconOnly
                  variant="ghost"
                  color="primary"
                  onPress={() => setLayout("bottom")}
                >
                  <IconLayoutBottombar />
                </Button>
                <Button
                  size="sm"
                  isIconOnly
                  variant="ghost"
                  color="primary"
                  onPress={() => setLayout("max")}
                >
                  <IconMaximize />
                </Button>
              </div>
            </div>
            {/* Put droppable here */}
            <Droppable id="display-deck">
              Test
              <div
                className={`overflow-scroll bg-default-50 rounded-lg p-2`}
                style={{ height: "calc(100vh - 140px)" }}
              >
                <div className="mt-4 flex flex-col gap-2">
                  {/* <SortableContext
                    items={deck.get()}
                    strategy={verticalListSortingStrategy}
                  >
                    {displayDeck}
                  </SortableContext> */}
                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                    autoScroll={false}
                  >
                    <SortableContext
                      items={cardOrderIds}
                      strategy={verticalListSortingStrategy}
                    >
                      {cardOrderIds.map((id: string) => (
                        <SortableItem key={id} id={id}>
                          {deck.getCard(id) && (
                            <DeckCardLeftSide
                              id={id}
                              count={deck.getCard(id).count}
                              addCard={addCard}
                            />
                          )}
                        </SortableItem>
                      ))}

                      {/* {items.map((id) => (
                        <SortableItem key={id} id={id}>
                          {id}
                        </SortableItem>
                      ))} */}
                      {/* {displayDeck} */}
                    </SortableContext>
                  </DndContext>
                </div>
              </div>
            </Droppable>
          </div>
        </div>
        <div className="col-span-3">
          <div className="flex flex-wrap gap-2 mt-4 mb-4 items-center">
            <NameFilter
              selected={filters.search}
              setSelected={(val: any) => setFilter("search", val)}
              placeholder={"Search"}
            />
            <DeckCommonCardsFilter
              selected={filters.deckCommonCards}
              setSelected={(val: any) => setFilter("deckCommonCards", val)}
              deckCardsMap={deckCardsMap}
            />
            <ColorFilter
              selected={filters.color}
              setSelected={(val: any) => setFilter("color", val)}
            />
            <CostFilter
              selected={filters.cost}
              setSelected={(val: any) => setFilter("cost", val)}
            />
            <PowerFilter
              selected={filters.power}
              setSelected={(val: any) => setFilter("power", val)}
            />
            <TypeFilter
              selected={filters.type}
              setSelected={(val: any) => setFilter("type", val)}
            />
            <CounterFilter
              selected={filters.counter}
              setSelected={(val: any) => setFilter("counter", val)}
            />
            <AttributeFilter
              selected={filters.attribute}
              setSelected={(val: any) => setFilter("attribute", val)}
            />
            <FormatFilter
              customData={formats}
              selected={filters.format}
              setSelected={(val: any) => setFilter("format", val)}
            />
            <ShowAAsFilter
              selected={filters.showAAs}
              setSelected={(val: any) => setFilter("showAAs", val)}
            />
            <Button
              // color="primary"
              // variant=""
              onPress={() => {
                clearAllFilters();
              }}
              radius="sm"
              className="h-[30px]"
              // endContent={<IconX height={14} width={14} />}
            >
              Clear
            </Button>
            {/* <Button>All Filters</Button> */}
          </div>
          <Suspense
            fallback={
              <div>
                <Spinner />
              </div>
            }
          >
            <div
              ref={scrollRef}
              className="overflow-scroll"
              style={{
                height: "calc(100vh - 140px)",
              }}
            >
              <div
                id="card-db"
                className="grid grid-cols-8 gap-0 pt-3 px-2 pb-2"
              >
                {displayCards}
              </div>
              {hasNextPage() && (
                <div
                  ref={sentinelRef}
                  className="flex justify-center py-4 min-h-[48px]"
                >
                  <Spinner size="sm" />
                </div>
              )}
            </div>
          </Suspense>
        </div>
      </div>
    </div>
  );
}
